<template>
	<!-- Displays detailed store information. -->
	<article class="info store">
		<!--
			Endast store markup för InfraCity för att validera markup live.
			Lägg till för alla när validering utförts.
			 -->
		<store-markup v-if="store" :store="store" />
		<section v-if="store" class="px-5">
			<h1>{{ store.name }}
				<label v-if="canAddFavoriteMark" class="stock-favorite" :title="favoriteTitle">
					<input type="checkbox" v-model="inUserSelection"><span />
				</label>
			</h1>
			<is-store-open :store="store" />
			<hr>
			<store-info-container
				:store="store"
				titleColor="#333333"
				addressColor="#969ba0"
				:useColLayout="true"
				forceShowGMaps />
			<div v-if="store.presentation">
				<html-description class="p-5 page-description" :html="store.presentation" :extended-html="store.presentationExtension" />
			</div>
			<!-- Nearby stores -->
			<h4 style="margin-top: 20px">Närliggande butiker</h4>
			<ul  class="list-group" :key="store.id" style="padding-left: 0px">
				<store-list-item v-for="store in nearbyStores" :key="store.id" :store="store" />
				<div class="mt-4">
					<router-link :to="standardRoute('info', { id: 5, name: 'Våra Butiker'})">Visa alla</router-link>
				</div>
			</ul>
		</section>
	</article>
</template>
<script>
import router from 'router';
import store from 'datastore';
import { mapState } from 'vuex';
import { urlFormat, error, geoDistSort, standardRoute } from 'utils';
import { setCustomNav } from 'datastore/navStatus';
import { t } from 'datastore/i18n';

export default {
	layoutOptions: {
		leftCol: true,
	},
	data () {
		return {
			urlFormat,
			error,
			geoDistSort,
			standardRoute,
		};
	},
	beforeRouteEnter (to, frm, next) {
		const storeMap = store.state.i18n.stores;
		if (Object.keys(storeMap).length && ! storeMap[to.params.id]) {
			next(error(404, 'Butiken kunde inte hittas'));
		}
		next();
	},
	beforeRouteUpdate (to, frm, next) {
		const storeMap = store.state.i18n.stores;
		if (to.name === frm.name && ! storeMap[to.params.id]) {
			next(error(404, 'Butiken kunde inte hittas'));
			return;
		}
		next();
	},
	computed: {
		inUserSelection: {
			get () {
				return this.userSettings.myStores.indexOf(this.store.id) >= 0;
			},
			set (checked) {
				const index = this.userSettings.myStores.indexOf(this.store.id);
				if (checked && index < 0) {
					this.$store.dispatch('userSettings/addStore', this.store.id);
				} else if (! checked && index >= 0) {
					this.$store.dispatch('userSettings/removeStore', this.store.id);
				}
			},
		},
		...mapState({
			userSettings: state => state.userSettings,
		}),
		favoriteMarkCount () {
			return this.userSettings.myStores.length;
		},
		favoriteTitle () {
			return this.ts('STAR');
		},
		canAddFavoriteMark () {
			if (this.store.id === 9999) { // @TODO övriga butiker, övergå till att använda strängar
				return false;
			}
			return ! (isNaN(this.store.id) || (this.favoriteMarkCount >= 3 && ! this.inUserSelection));
		},
		storeMap () {
			return this.$store.state.i18n.stores;
		},
		store () {
			if (! this.storeMap || ! this.storeMap[this.$route.params.id]) return null;
			return this.storeMap[this.$route.params.id];
		},
		/**
		 * All stores except the store displayed on this page.
		 */
		stores () {
			const stores = [];
			for (const store of this.allStores) {
				if (store.id !== this.store.id) {
					stores.push(store);
				}
			}
			return stores;
		},
		/**
		 * The three closest stores to the current store.
		 */
		nearbyStores () {
			return geoDistSort(this.store.location, this.stores).slice(0, 3);
		},
		...mapState({
			allStores: state => state.i18n.storeList,
		}),
	},
	methods: {
		ts: t.prefix('STOCK'),
		updateRouteAndNav () {
			router.updateParams({
				id: this.store.id,
				name: urlFormat(this.store.name),
			});

			const navigationPath = [
				{
					title: 'Kundservice',
					route: { name: 'info', params: { id: 1, name: urlFormat('Kundservice'), title: 'Kundservice' } },
				},
				{
					title: 'Våra butiker',
					route: { name: 'info', params: { id: 5, name: urlFormat('Våra butiker'), title: 'Våra butiker' } },
				},
				{
					title: this.store.name,
					route: null,
				},
			];

			setCustomNav({
				customPath: navigationPath,
			});
		},
	},
	watch: {
		storeMap (map) {
			// Handle 404 errors for when the stores get loaded the first time.
			if (Object.keys(map).length) {
				if (! this.store) {
					error(404, 'Butiken kunde inte hittas')(this);
				}
			}
		},
		store (to) {
			if (to) {
				this.updateRouteAndNav();
			}
		},
	},
	mounted () {
		if (this.store) {
			this.updateRouteAndNav();
		}
	},
};
</script>
